import { render } from "./OptionalFields.vue?vue&type=template&id=191a8c92&scoped=true"
import script from "./OptionalFields.vue?vue&type=script&lang=js"
export * from "./OptionalFields.vue?vue&type=script&lang=js"

import "./OptionalFields.vue?vue&type=style&index=0&id=191a8c92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-191a8c92"]])

export default __exports__